// extracted by mini-css-extract-plugin
export default {"image":"tW-z","loaded":"uW-z"};